<template>
  <div>
    <data-detail-row
      :oldValueData="oldValue('merchant_name') != false"
      :data="data"
      :label="merchantTypeId == '1' ? 'Nama Merchant' : 'Nama Sub Merchant'"
      :valueData="data.merchant_name"
      :oldData="oldValue('merchant_name')"
    />
    <data-detail-row
      :oldValueData="oldValue('nmid') != false"
      :data="data"
      :label="'NMID'"
      :valueData="data.nmid"
      :oldData="oldValue('nmid')"
    />
    <data-detail-row
      :oldValueData="oldValue('mpan') != false"
      :data="data"
      :label="'MPAN'"
      :valueData="data.mpan"
      :oldData="oldValue('mpan')"
    />
    <data-detail-row
      :oldValueData="oldValue('mid') != false"
      :data="data"
      :label="'MID'"
      :valueData="data.mid"
      :oldData="oldValue('mid')"
    />
    <data-detail-row
      :oldValueData="oldValue('ktp_no') != false"
      :data="data"
      :label="'Nomor KTP Pemilik Usaha'"
      :valueData="text(data.ktp_no)"
      :oldData="oldValue('ktp_no')"
    />
    <data-detail-row
      :oldValueData="oldValue('npwp_no') != false"
      :data="data"
      :label="
        accountType == 'Corporate'
          ? 'Nomor NPWP Perusahaan'
          : 'Nomor NPWP Pemilik Usaha'
      "
      :valueData="text(data.npwp_no)"
      :oldData="oldValue('npwp_no')"
    />
    <data-detail-row
      :oldValueData="oldValue('account_type') != false"
      :data="data"
      :label="merchantTypeId == '1' ? 'Tipe Merchant' : 'Tipe Sub Merchant'"
      :valueData="tipeMerchantText(data.account_type)"
      :oldData="oldValue('account_type')"
    />
    <data-detail-row
      :oldValueData="oldValue('qr_type') != false"
      :data="data"
      :label="'Tipe QR'"
      :valueData="data.qr_type"
      :oldData="oldValue('qr_type')"
    />
    <data-detail-row
      :oldValueData="oldValue('mcc_name') != false"
      :data="data"
      :label="'Jenis Usaha'"
      :valueData="data.mcc_name"
      :oldData="oldValue('mcc_name')"
    />
    <data-detail-row
      :oldValueData="oldValue('merchant_criteria') != false"
      :data="data"
      :label="merchantTypeId == '1' ? 'Merchant' : 'Sub Merchant'"
      :valueData="criteriaText(data.merchant_criteria)"
      :oldData="
        oldValue('merchant_criteria') != false
          ? criteriaText(oldValue('merchant_criteria'))
          : ''
      "
    />
    <data-detail-row
      :oldValueData="
        oldValue('kabupaten_kota') != false ||
        oldValue('kecamatan') != false ||
        oldValue('kode_pos_id') != false
      "
      :data="data"
      :label="'Kota, Kecamatan, Kode Pos'"
      :valueData="
        data.kabupaten_kota + ', ' + data.kecamatan + ', ' + data.kode_pos_id
      "
      :oldData="
        oldValue('kabupaten_kota') != false ||
        oldValue('kecamatan') != false ||
        oldValue('kode_pos_id') != false
          ? getOldValue('kabupaten_kota') +
            ', ' +
            getOldValue('kecamatan') +
            ', ' +
            getOldValue('kode_pos_id')
          : ''
      "
    />
    <data-detail-row
      :oldValueData="oldValue('reason') != false"
      :data="data"
      :label="'Remark'"
      :valueData="data.reason"
      :oldData="oldValue('reason')"
    />
    <data-detail-row
      :oldValueData="oldValue('approver_1') != false"
      :data="data"
      :label="'ID Approver 1'"
      :valueData="data.approver_1"
      :oldData="oldValue('approver_1')"
    />
    <data-detail-row
      :oldValueData="oldValue('approver_2') != false"
      :data="data"
      :label="'ID Approver 2'"
      :valueData="data.approver_2"
      :oldData="oldValue('approver_2')"
    />

    <v-card
      class="mb-12"
      height="20px"
      :style="{ 'box-shadow': '0 0 black', 'margin-top': '20px' }"
    >
      <div class="d-flex pa-5 flex-column align-center justify-center">
        <h3>Additional Data</h3>
      </div>
    </v-card>

    <data-detail-row
      :oldValueData="oldValue('owner_city_of_birth') != false"
      :data="data"
      :label="'Tempat Lahir Pemilik Usaha'"
      :valueData="text(data.owner_city_of_birth)"
      :oldData="oldValue('owner_city_of_birth')"
    />
    <data-detail-row
      :oldValueData="oldValue('owner_date_of_birth') != false"
      :data="data"
      :label="'Tanggal Lahir Pemilik Usaha'"
      :valueData="text(data.owner_date_of_birth)"
      :oldData="oldValue('owner_date_of_birth')"
    />
    <data-detail-row
      :oldValueData="oldValue('owner_address') != false"
      :data="data"
      :label="'Alamat Pemilik Usaha'"
      :valueData="text(data.owner_address)"
      :oldData="oldValue('owner_address')"
    />
    <data-detail-row
      :oldValueData="oldValue('owner_postal_code') != false"
      :data="data"
      :label="'Kode Pos Pemilik Usaha'"
      :valueData="text(data.owner_postal_code)"
      :oldData="oldValue('owner_postal_code')"
    />
    <data-detail-row
      :oldValueData="oldValue('account_holder_name') != false"
      :data="data"
      :label="'Nama Pemilik Rekening'"
      :valueData="text(data.account_holder_name)"
      :oldData="oldValue('account_holder_name')"
    />
    <data-detail-row
      :oldValueData="oldValue('bni_branch_office') != false"
      :data="data"
      :label="'Kantor Cabang Terdekat'"
      :valueData="text(data.bni_branch_office)"
      :oldData="oldValue('bni_branch_office')"
    />
    <data-detail-row
      :oldValueData="oldValue('merchant_est_since') != false"
      :data="data"
      :label="'Tahun Berdiri'"
      :valueData="text(data.merchant_est_since)"
      :oldData="oldValue('merchant_est_since')"
    />
    <data-detail-row
      :oldValueData="oldValue('merchant_email') != false"
      :data="data"
      :label="'Email Merchant'"
      :valueData="text(data.merchant_email)"
      :oldData="oldValue('merchant_email')"
    />

    <div v-if="data.image_ktp">
      <v-card
        class="mb-12"
        height="20px"
        :style="{ 'box-shadow': '0 0 black', 'margin-top': '20px' }"
      >
        <div class="d-flex pa-5 flex-column align-center justify-center">
          <h3>Dokumen</h3>
        </div>
      </v-card>

      <v-row>
        <v-col cols="10" sm="4"> Foto Selfi </v-col>
        <v-col cols="2" sm="1"> : </v-col>
        <v-col cols="12" sm="7">
          <v-card elevation="2">
            <v-img :src="data.image_selfie" />
          </v-card>
        </v-col>
      </v-row>

      <v-row>
        <v-col cols="10" sm="4"> Foto KTP </v-col>
        <v-col cols="2" sm="1"> : </v-col>
        <v-col cols="12" sm="7">
          <v-card elevation="2">
            <v-img :src="data.image_ktp" />
          </v-card>
        </v-col>
      </v-row>

      <v-row>
        <v-col cols="10" sm="4"> Foto Selfi KTP </v-col>
        <v-col cols="2" sm="1"> : </v-col>
        <v-col cols="12" sm="7">
          <v-card elevation="2">
            <v-img :src="data.image_selfie_ktp" />
          </v-card>
        </v-col>
      </v-row>

      <v-row>
        <v-col cols="10" sm="4"> Foto TTD </v-col>
        <v-col cols="2" sm="1"> : </v-col>
        <v-col cols="12" sm="7">
          <v-card elevation="2">
            <v-img :src="data.image_tanda_tangan" />
          </v-card>
        </v-col>
      </v-row>

      <v-row>
        <v-col cols="10" sm="4"> Foto Lokasi Usaha </v-col>
        <v-col cols="2" sm="1"> : </v-col>
        <v-col cols="12" sm="7">
          <v-card elevation="2">
            <v-img :src="data.image_lokasi" />
          </v-card>
        </v-col>
      </v-row>

      <v-row>
        <v-col cols="10" sm="4"> Foto NPWP </v-col>
        <v-col cols="2" sm="1"> : </v-col>
        <v-col cols="12" sm="7">
          <v-card elevation="2">
            <v-img :src="data.image_npwp" />
          </v-card>
        </v-col>
      </v-row>

      <v-row>
        <v-col cols="10" sm="4"> Foto NIB </v-col>
        <v-col cols="2" sm="1"> : </v-col>
        <v-col cols="12" sm="7">
          <v-card elevation="2">
            <app-pdf-viewer
              :id="$route.params.id"
              :pdfData="data.image_nib"
              pdfType="pdfNib"
            />
          </v-card>
        </v-col>
      </v-row>
    </div>
  </div>
</template>

<script>
import { text } from '../../lib/helpers';
import { dataListMerchantCriteria } from '../../store/params';

export default {
  components: {
    DataDetailRow: () => import('./DataDetailRow.vue'),
    AppPdfViewer: () => import('../form/AppPdfViewer.vue'),
  },
  props: ['data'],
  data() {
    return {
      merchant_type: 'Merchant',
      loadingSave: false,
      // qrisFile: null,
      dialog: false,
      dialogReject: false,
      dialogSendback: false,
      loading: false,
      remark: '',
      idTaskAdd: ['0', '2', '3'],
      idTaskEdit: ['4', '5', '6', '14'],
      criteriaMerchantText: dataListMerchantCriteria,
    };
  },
  computed: {
    isCloseMerchant() {
      return this.data != null && this.data.task_type_id.toString() == '7';
    },

    isTypeSettlement() {
      return this.data != null && this.data.task_type_id.toString() == '15';
    },
    merchantPhone() {
      const area =
        this.data.phone_area_code != '' && this.data.phone_area_code != null
          ? `(${this.data.phone_area_code})`
          : '';
      const phone = this.data.phone != null ? this.data.phone : '';
      return `${area} ${phone}`;
    },
    accountType() {
      return this.data != null ? this.data.account_type : null;
    },
    merchantTypeId() {
      if (this.data != null) {
        if (this.data.merchant_type_id != null) {
          return this.data.merchant_type_id;
        }
        return '1';
      }
      return '1';
    },
  },
  methods: {
    oldValue(variable) {
      if (
        this.data.old_value != null &&
        this.data.old_value[variable] != null &&
        this.data[variable] != this.data.old_value[variable]
      ) {
        return this.data.old_value[variable];
      }
      return false;
    },
    getOldValue(variable) {
      return this.data.old_value[variable];
    },

    convertMerchantPhone(phoneAreaCode, phone) {
      const area =
        phoneAreaCode != '' && phoneAreaCode != null
          ? `(${phoneAreaCode})`
          : '';
      const phoneText = phone != null ? phone : '';
      return `${area} ${phoneText}`;
    },
    tipeMerchantText(textVal) {
      return textVal.toLowerCase() == 'corporate' ? 'Badan Usaha' : textVal;
    },
    criteriaText(value) {
      const find = this.criteriaMerchantText.find((x) => value == x.value);
      return find != undefined ? find.text : value;
    },
    text,
  },
};
</script>
